/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
  GetApiV1NotificationMobileAppNotificationidPreviewPathParams,
  GetApiV1NotificationMobileAppNotificationidPreview401,
  GetApiV1NotificationMobileAppNotificationidPreview404,
  GetApiV1NotificationMobileAppNotificationidPreview500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppNotificationidPreview.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1NotificationMobileAppNotificationidPreview } from "../../clients/notificationMobileAppController/getApiV1NotificationMobileAppNotificationidPreview.ts";

export const getApiV1NotificationMobileAppNotificationidPreviewQueryKey = (
  notificationId: GetApiV1NotificationMobileAppNotificationidPreviewPathParams["notificationId"],
) =>
  [
    {
      url: "/api/v1/notification/mobile-app/:notificationId/preview",
      params: { notificationId: notificationId },
    },
  ] as const;

export type GetApiV1NotificationMobileAppNotificationidPreviewQueryKey =
  ReturnType<typeof getApiV1NotificationMobileAppNotificationidPreviewQueryKey>;

export function getApiV1NotificationMobileAppNotificationidPreviewQueryOptions(
  notificationId: GetApiV1NotificationMobileAppNotificationidPreviewPathParams["notificationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1NotificationMobileAppNotificationidPreviewQueryKey(notificationId);
  return queryOptions<
    GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppNotificationidPreview401
      | GetApiV1NotificationMobileAppNotificationidPreview404
      | GetApiV1NotificationMobileAppNotificationidPreview500
    >,
    GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
    typeof queryKey
  >({
    enabled: !!notificationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1NotificationMobileAppNotificationidPreview(
        notificationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna título, mensagem, turmas (nomes para exibição + IDs), status de matrícula, URL externa, agendamento e status atual da notificação. **(Requer Authorization para autenticação)**
 * @summary Retorna os dados de uma notificação para edição (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/:notificationId/preview}
 */
export function useGetApiV1NotificationMobileAppNotificationidPreview<
  TData = GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
  TQueryData = GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1NotificationMobileAppNotificationidPreviewQueryKey,
>(
  notificationId: GetApiV1NotificationMobileAppNotificationidPreviewPathParams["notificationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
        ResponseErrorConfig<
          | GetApiV1NotificationMobileAppNotificationidPreview401
          | GetApiV1NotificationMobileAppNotificationidPreview404
          | GetApiV1NotificationMobileAppNotificationidPreview500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1NotificationMobileAppNotificationidPreviewQueryKey(notificationId);

  const query = useQuery(
    {
      ...getApiV1NotificationMobileAppNotificationidPreviewQueryOptions(
        notificationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppNotificationidPreview401
      | GetApiV1NotificationMobileAppNotificationidPreview404
      | GetApiV1NotificationMobileAppNotificationidPreview500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
